var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.011 85.3h-.005C48.186 85.283 8.93 62.237 8.93 38.4c0-13.289 10.168-23.7 23.148-23.7a25.321 25.321 0 0 1 17.976 6.874c2.3-2.351 8-6.874 17.706-6.874 13.071 0 23.31 10.41 23.31 23.7 0 8.712-5.056 18.129-15.028 27.988C65.7 76.607 51.658 85.3 50.011 85.3ZM32.078 17.7c-11.3 0-20.148 9.092-20.148 20.7 0 11.245 9.945 22.346 18.287 29.678a119.082 119.082 0 0 0 19.819 14.1C54.8 79.821 88.07 59.018 88.07 38.4c0-11.607-8.921-20.7-20.31-20.7-11.273 0-16.255 6.71-16.461 7a1.5 1.5 0 0 1-1.2.623 1.485 1.485 0 0 1-1.214-.589c-.052-.078-5.485-7.034-16.807-7.034Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.202f3b2bf13fb375f66496e53692264f.svg";
export { ForwardRef as ReactComponent };